import { render } from "./PortfolioDetails.vue?vue&type=template&id=089ea9be"
import script from "./PortfolioDetails.vue?vue&type=script&lang=js"
export * from "./PortfolioDetails.vue?vue&type=script&lang=js"

import "./PortfolioDetails.vue?vue&type=style&index=0&id=089ea9be&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__